import { create } from 'zustand';
import { immerMiddleware } from '../services/Utils';
import { POST_PRIVACY } from '../types/postsTypings';
import { useUserStore } from './UserStore';

export const defaultPage = {
  title: '',
  image: '',
  details: '',
  privacy: POST_PRIVACY.PRIVATE,
  editable: 'false',
  hideUser: 'false',
  users: []
};

const pagesStore = set => ({
  page: defaultPage,
  setPage: page => {
    set(state => {
      state.page = page;
    });
  },
  setTitle: title => {
    set(state => {
      state.page.title = title;
    });
  },
  setImage: image => {
    set(state => {
      state.page.image = image;
    });
  },
  setDetails: details => {
    set(state => {
      state.page.details = details;
    });
  },
  setEditable: editable => {
    set(state => {
      state.page.editable = editable;
    });
  },
  setHideUser: hideUser => {
    set(state => {
      state.page.hideUser = hideUser;
    });
  },
  setPrivacy: privacy => {
    set(state => {
      const myUuid = useUserStore.getState().UUID;
      state.page.privacy = privacy;
      if (privacy === 'PUBLIC') {
        state.page.users = [myUuid];
      }
    });
  },
  setUsers: users => {
    set(state => {
      state.page.users = users;
    });
  }
});

export const usePagesStore = create(immerMiddleware(pagesStore));
